<template>
  <el-select  class="h-40 mw-240 w-100p" filterable clearable :placeholder="placeholder" v-model="childValue" @input="change" :disabled="disabled">
    <el-option :label="option.name" :value="option.value" v-for="option in options"></el-option>
  </el-select>
</template>
<script>
  /**
   * @param Number value 绑定值
   * @param String name 控件名
   * @param Boolean disabled 是否禁用
   * @param Array rules 表单验证规则
   * @param Array options 选项值
   * @param String placeholder 提示语
   */
  import modelConfig from '../../../../config/modelConfig'
  import _verify from '../../../../assets/js/verify'
  export default {
    props: ['value', 'name', 'disabled', 'rules', 'options', 'placeholder'],
    data() {
      return {
        childValue: null
      }
    },
    created() {
      this.initData()
    },
    methods: {
      initData() {
        if (this.value) {
          this.childValue = this.value
        } else if (this.value == null) {
          this.setDefaultValue()
        } else {
          this.childValue = ''
        }
      },
      setDefaultValue() {
        this.childValue = ''
        _(this.options).forEach((res) => {
          if (res.is_selected) {
            this.childValue = res.value
            this.change(this.childValue)
            return
          }
        })
      },
      change(value) {
        this.$emit('input', value)
      }
    },
    watch: {
      'value'() {
        if (this.value != this.childValue) {
          this.initData()
        }
      }
    },
    mixins: [modelConfig]
  }
</script>



// WEBPACK FOOTER //
// honraySelect.vue?124c17c4